// src/components/inputs/IntInput.js
import { Input, Slider, Typography } from "@material-tailwind/react";

import PropTypes from "prop-types";
import React from "react";

const IntInput = ({ label, value, onChange, min, max }) => {
  const safeId = `int-input-${label.replace(/\s+/g, "-").toLowerCase()}`;

  if (min && max) {
    /* Use a slider if both min and max are provided and show the int value  */
    return (
      <div className="flex gap-2 h-full mb-4">
        <div className="flex justify-between w-2/5">
          <Typography variant="paragraph" color="black" className="my-auto">
            {label}
          </Typography>

          <div className="w-content my-auto bg-black rounded-lg px-2">
            <Typography variant="h5" color="white" className="my-auto w-1/2">
              {value}
            </Typography>
          </div>
        </div>

        <div className="my-auto w-2/5">
          <Slider
            size="sm"
            type="range"
            id={safeId}
            label={label}
            value={((value - min) / (max - min)) * 100}
            min={1}
            max={100}
            about="slider"
            onChange={(e) => {
              onChange(Math.round((e.target.value / 100) * (max - min) + min));
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="mb-4">
      <Input
        id={safeId}
        label={label}
        type="number"
        value={value}
        onChange={(e) => {
          const newValue = parseInt(e.target.value, 10);
          if (!isNaN(newValue)) {
            onChange(newValue);
          } else {
            onChange("");
          }
        }}
        className="transition-colors duration-300"
      />
    </div>
  );
};

IntInput.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default IntInput;
